import { render, staticRenderFns } from "./SegmentsCustomerList.vue?vue&type=template&id=72fefc01&scoped=true"
import script from "./SegmentsCustomerList.vue?vue&type=script&lang=ts"
export * from "./SegmentsCustomerList.vue?vue&type=script&lang=ts"
import style0 from "./SegmentsCustomerList.vue?vue&type=style&index=0&id=72fefc01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fefc01",
  null
  
)

export default component.exports